/** @jsxImportSource @emotion/react */
export default function CampoInformacion({ children, nombreCampo, anchoCompleto }) {
  return (
    <div
      css={{ marginBottom: "0.8em" }}
      className={anchoCompleto ? "col-12" : "col-12 sm:col-12 md:col-6 lg:col-4 xl:col-4"}
    >
      <div
        css={{ color: "var(--grisTextos)", marginBottom: "4px" }}
      >{`${nombreCampo}:`}</div>
      <div css={{ whiteSpace: "pre-wrap" }}>{children}</div>
    </div>
  );
}
